import type { InvoiceBillingAddress } from './invoiceUtils'

export const resolveInvoiceBillingAddressGuid = (address: InvoiceBillingAddress): string | undefined => {
  if (address.type === 'account_billing_address') return address.accountBillingAddressGuid
  if (address.type === 'adhoc') return address.persistedAddressGuid
  return undefined
}
